module.exports = __webpack_public_path__ + "static/media/disfraz-parejas.0849c833.jpg";